export default {
  'site-name': 'Gifta Blog',
  'site-title': 'Gifta Blog',
  'gifta-site-title': 'Gifta Website',
  'gifta-site-link': 'https://www.gifta.es/',
  'pixa-site-title': 'Pixartprinting Website',
  'pixa-site-link': 'https://www.pixartprinting.es/',
  'load-more-article': 'Leer otros artículos',
  'next-slide': 'Siguiente',
  'prev-slide': 'Anterior',
  'next-pagination': 'Siguientes',
  'prev-pagination': 'Anteriores',
  'next-article': 'Artículo siguiente',
  'related-articles': 'Artículos relacionados',
  'back-to-top': 'Volver a',
  search: 'Search',
  'erase-research': 'Eliminar búsqueda',
  close: 'Cerrar',
  'newsletter-title': 'Newsletter',
  'newsletter-text':
    'Sii tra i primi ad essere aggiornato <br> sulle novità di Gifta blog.',
  'newsletter-cta': 'Suscríbete',
}
